import Box from 'components/Box';
import React from 'react';
import shopSelectors from 'services/selectors/shop';
import qbSignal from './signal';
import styled from 'styled-components';
import clsx from 'clsx';

const GroupNumberSection = () => {
  const groupAssignEnabled = shopSelectors.setting().quickBookingGroupAssign;
  const handleChangeTotalPeople = (val: number) => {
    qbSignal.totalPeople.value = val;
    // Nhom di qua buoc gan tho va tao nhieu lich cung luc, khong lap thanh chuoi duoc. Bo gia
    // tri lap ngay tai day, neu khong payload van mang chu ky ma nguoi dung khong con o nao de go.
    if (groupAssignEnabled && val >= 2) qbSignal.repeatDayRepeat.value = null;
  };
  return (
    <Container className="section-wrapper" style={{ flex: 1 }}>
      <Box display='flex' alignItems='center'>
        <div style={{ flex: 1 }} className="section-label">GROUP CUSTOMERS</div>
        <div className='input-number-customer' >
          <span>{qbSignal.totalPeople.value || '1'}</span>
        </div>
      </Box>
      <InputNumberBox value={qbSignal.totalPeople.value} onChange={handleChangeTotalPeople} />
    </Container>
  );
};

export default GroupNumberSection;
type InputNumberBoxProps = {
  value?: number;
  onChange?: (value: number) => void;
};
const InputNumberBox = ({ value, onChange }: InputNumberBoxProps) => {
  const handleChange = (value: number) => {
    onChange?.(value);
  };
  return (
    <InputNumberBoxContainer>
      {Array.from({ length: 9 }).map((_, index) => (
        <button type='button' key={index} className={clsx('input-number-customer-item', { active: value?.toString() === (index + 1).toString() })} onClick={() => handleChange(index + 1)}>
          <span>{index + 1}</span>
        </button>
      ))}
    </InputNumberBoxContainer>
  );
};

const Container = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: column;
  .input-number-customer {
    display: flex;
    width: 120px;
    height: 48px;
    justify-content: center;
    align-items: center;
    gap: 18px;
    border-radius: 4px;
    border: 1px solid #86909C;
    background: #FFF;
    span {
      color: #1D2129;
      text-align: center;
      font-family: Poppins;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 30px;
      text-transform: uppercase;
    }
  }
`;
const InputNumberBoxContainer = styled.div`
  display: flex;
  height: 56px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  .input-number-customer-item {
    display: flex;
    padding: 4px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0 0;
    align-self: stretch;
    border-radius: 5px;
    background: #E5E6EB;
    &:active {
      opacity: 0.5;
    }
    span {
      color: #1D2129;
      text-align: center;
      font-family: Poppins;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 30px;
      text-transform: uppercase;
      align-self: stretch;
    }

    &.active {
      background: #1D2129;
      span {
        color: #FFF;
      }
    }
  }
`;